import { styled } from "@mui/material";
import { Tree } from "@volt_developers/components";

import { FilterListItemSkeleton } from "./FilterListItemSkeleton";

const SkeletonWrapper = styled("div")({});

export const FilterFlatListSkeleton = () => (
  <SkeletonWrapper>{skeleton}</SkeletonWrapper>
);

const skeleton = Array.from({ length: 10 }).map((_, index) => (
  <Tree.ItemContentWrapper key={index} nodeDepth={1} sx={{ display: "flex" }}>
    <FilterListItemSkeleton />
  </Tree.ItemContentWrapper>
));
